import { useActiveOrgId } from '@/hooks/useActiveOrgId'
import { useUserStore } from '@/store/UserStore'
import { Inference, RoleID } from './inference.gen'

export const API_URL = import.meta.env.VITE_API_URL as string

export const RPCFetch = async (
  input: RequestInfo,
  init?: RequestInit
): Promise<Response> => {
  const token = useUserStore.getState().user?.token || ''
  const orgId = window.location.pathname.split('/')[1] // TODO: need a more reliable way to get orgId

  const resRaw = await fetch(input, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      // only send orgId if it is a number TODO: need a more reliable way to get orgId
      ...(orgId && !isNaN(Number(orgId)) ? { 'Org-ID': orgId.toString() } : {}),
      ...init?.headers,
    } as HeadersInit,
  })

  return resRaw
}

export const InferenceAPI = new Inference(API_URL, RPCFetch)

// utility function to get the token & orgId
export const useTokenAndOrgId = () => {
  const { orgId } = useActiveOrgId()
  const token = useUserStore((state) => state.user?.token) || ''
  return { orgId, token }
}

export const processPaginatedData = <T>(
  pages: Array<{ instances?: T[]; users?: T[]; total?: number } | undefined>
) => {
  const allInstances = pages.flatMap(
    (page) => page?.instances || page?.users || []
  )
  const total = pages[0]?.total || 0

  return { allInstances, total }
}

/* ********* Role UTILS ********* */
export const isRoleManager = (role: string | undefined) =>
  role === RoleID.Manager
export const isRoleAdmin = (role: string | undefined) => role === RoleID.Admin
export const isRoleUser = (role: string | undefined) => role === RoleID.User
export const hasAdminPrivileges = (role: string | undefined) =>
  role === RoleID.Admin || role === RoleID.Manager

export const numToRoleID = (role: number | undefined) => {
  if (!role) throw new Error(`Invalid role ID: ${role}`)

  switch (role) {
    case 1:
      return RoleID.Admin
    case 2:
      return RoleID.User
    case 3:
      return RoleID.Manager
    default:
      throw new Error(`Invalid role ID: ${role}`)
  }
}
